module.exports = __webpack_public_path__ + "img/undraw-segmentation.746980a7.svg";